import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { Endpoints } from './endpoints';
import { catchError } from 'rxjs/operators';
import { BsError } from '../models/shared/bs-error';
import { ApiErrorLog } from '../models/shared/api-error-log';
import { Display } from '../models/display/dto/display';
import { RefreshDisplays } from '../models/display/dto/refresh-displays';
import { Api } from './api';
import { TrackApiCall } from '../services/data-sync/track-api-call';

@Injectable({ providedIn: 'root' })
export class DisplayAPI extends Api {
  serviceName = 'Display';

  public refreshDisplays$(payload: RefreshDisplays): Observable<any> {
    const url = Endpoints.RefreshDisplays();
    return this.apiClient.postObjGetArray$(Display, url, payload).pipe(
      catchError(e => {
        const err = new BsError(e, this.serviceName);
        this.loggingService.LogAPIError(new ApiErrorLog(this.serviceName, 'RefreshDisplays', err));
        return throwError(() => err);
      })
    );
  }

  @TrackApiCall()
  public getCompanyDisplays$(companyId: number): Observable<Display[]> {
    const url = Endpoints.GetCompanyDisplays();
    const additionalHeaders = { CompanyId: companyId?.toString() };
    return this.apiClient.getArr$(Display, url, additionalHeaders).pipe(
      catchError(e => {
        const err = new BsError(e, this.serviceName);
        this.loggingService.LogAPIError(new ApiErrorLog(this.serviceName, 'GetCompanyDisplays', err));
        return throwError(() => err);
      })
    );
  }
}
